//@ts-nocheck
import { slugBuilder } from "./slug-builder";
import { toWords } from 'number-to-words';

function extractImportantText(html) {
    if (!html) return "";

    // Extract content inside <h1>, <h2>, <h3>, <li>
    const matches = html.match(/<h[1-3][^>]*>(.*?)<\/h[1-3]>|<li[^>]*>(.*?)<\/li>/gi);

    return matches
        ? matches.map(tag => tag.replace(/<\/?[^>]+(>|$)/g, "")).join(" ")  // Remove HTML tags
        : "";
}

export function extractKeywords(text) {
    if (!text) return [];

    // Remove special characters except numbers and split into words
    const words = text
        .toLowerCase()
        .replace(/[^a-zA-Z0-9\s]/g, "") // Remove punctuation
        .split(/\s+/) // Split by spaces

    // Common stop words to exclude
    const stopWords = new Set(["the", "and", "of", "in", "to", "for", "with", "on", "at", "by", "a", "an", "is", "it", "this", "that", "as", "or", "be", "are", "was", "were"]);

    // Function to convert numbers to words and keep the numberd
    const convertNumberToWords = (word) => {
        if (!isNaN(word)) {
            const wordNumber = toWords(Number(word)); // Convert number to words
            return [word, wordNumber]; // Return both the number and the word equivalent
        }
        return [word]; // If not a number, return the word as is
    }

    // Filter out stop words and short words, then add number/word pairs
    const filteredWords = words
        .filter(word => word.length >= 1 && !stopWords.has(word))
        .flatMap(word => convertNumberToWords(word)); // Flatten the array from the conversion

    // Return unique keywords
    return [...new Set(filteredWords)];
}

export const vxiContentInterpreter = (content = {}) => {
    // if(content?.title === "Rethinking Revenue: How B2B and B2C Brands Can Build Smarter, Scalable Sales Engines.") console.log("Interpreting content:", content);
    const vxiContent = content?.vxiContent?.attributes || {};
    const navigationSplit = content?.navigationSplit || {};
    const author = vxiContent?.author?.attributes || {};
    const preBuiltAuthor = vxiContent?.preBuiltAuthor?.attributes || {};
    const imagesData = vxiContent?.images?.data || content?.vxiContent?.images?.data || [];
    const supportImagesData = vxiContent?.supportImages?.data || [];
    const types = content?.type?.attributes?.title || content?.type?.data?.attributes?.title;
    // if (content.title === "VXI & LG Electronics Honored for Direct-to-Consumer Online Sales Experience with Two Gold 2025 Stevie® Awards") console.log("Images data:", imagesData, "VS content", content);
    const publishDate = new Date(content?.publishDate || 0).getTime();
    const left = content.left?.attributes || {};
    const right = content.right?.attributes || {};
    const titleFetcher = (data, target) => {
        return data?.page?.data?.attributes?.[target];
    };
    // Normalize Strapi relation shapes: supports Strapi v4 { data: [{ attributes: { title } }] },
    // flattened search-controller shapes [{ title }], [{ attributes: { title } }], or plain string arrays.
    const pluckTitles = (rel) => {
        const arr = Array.isArray(rel) ? rel : rel?.data;
        if (!Array.isArray(arr)) return [];
        return arr
            .map((item) => item?.attributes?.title ?? item?.title ?? (typeof item === "string" ? item : undefined))
            .filter(Boolean);
    };

    return {
        source: content?.source,
        id: content.id,
        left: left,
        right: right,
        title: content.title,
        hubSpotLink: content.hubSpotLink,
        types: typeof content?.readingTime === "boolean" ? "CXA Hub" : types,
        sections: typeof content?.readingTime === "boolean" ? "Resources" : (content?.section?.attributes?.title || content?.section?.data?.attributes?.title),
        solutions: pluckTitles(content?.solutions),
        industries: pluckTitles(content?.industries),
        datePublished: typeof content?.readingTime === "boolean" && publishDate === 0
            ? new Date().toISOString()
            : new Date(publishDate).toISOString(),
        authorFullName: preBuiltAuthor?.authorFullName || author?.authorFullName || null,
        authorTitle: preBuiltAuthor?.authorTitle || author?.authorTitle || "",
        authorLink: preBuiltAuthor?.authorLink || author?.authorLink || "",
        authorImage: preBuiltAuthor?.authorImage?.attributes?.url || author?.authorImage?.attributes?.url || "",
        heroDescription: vxiContent?.heroDescription || "",
        mainContent: vxiContent?.mainContent || "",
        supportImages: Array.isArray(supportImagesData)
            ? supportImagesData.map(img => img?.attributes?.url || "")
            : (supportImagesData?.attributes?.url || ""),
        images: Array.isArray(imagesData)
            ? imagesData.map(img => img?.attributes?.url || "")
            : (imagesData?.data?.map(img => img?.attributes?.url || []) || []),
        navigationSplit: navigationSplit || "",
        public: content?.public != null ? content?.public : false,
        readingTime: content?.readingTime != null ? content?.readingTime : false,
        keywords: [
            ...extractKeywords(content.title),
            ...extractKeywords(extractImportantText(vxiContent.mainContent)),

            ...pluckTitles(content?.solutions),

            ...pluckTitles(content?.industries),

            ...(content?.section?.attributes?.title
                ? [content.section.attributes.title]
                : []
            ),

            ...(content?.type?.attributes?.title
                ? [content.type.attributes.title]
                : []
            ),

            ...(author?.authorTitle
                ? [author?.authorTitle]
                : []
            ),

            ...(author?.authorFullName
                ? [author?.authorFullName]
                : []
            )
        ]
            .filter((value, index, self) => value && self.indexOf(value) === index),
        referenceList: content?.referenceList
    };
};

// export const WhatsNew = (content = []) => {
//     content = WhatsPublic(content) 
//         .sort((a, b) => new Date(b.datePublished) - new Date(a.datePublished)) // Sort by datePublished (newest first)
//         .slice(0, 8);
//     // console.log("****************** ", content);

//     return content;
// };

export const WhatsNew = async (content = []) => {
    const filtered = WhatsPublic(content)
        .sort((a, b) => new Date(b.datePublished) - new Date(a.datePublished))
        .slice(0, 8);

    const results = await Promise.all(
        filtered.map(async (contentItem) => {
            try {
                const response = await fetch(
                    `/api/result-blogs?id=${contentItem.id}&endpoint=vxi-contents`
                );

                const json = await response.json();
                return json?.data || null;
            } catch (err) {
                console.error("Failed to fetch blog:", err);
                return null;
            }
        })
    );
   // console.log("whats new: ", results);

    // remove failed ones
    return results.filter(Boolean);
};

export const WhatsPublic = (content = []) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return content?.filter(item => {
        const isPublic = item?.public;
        const publishDate = new Date(item?.datePublished);
        publishDate.setHours(0, 0, 0, 0);

        const isPublished = publishDate <= today;
        //if(item?.title === "CX Acceleration Hub Testing without publish date, reading time, and author") console.log(isPublic && isPublished, item);
        return isPublic && isPublished;
    });
};

export const ContentSorter = (content = []) => {
    // const filteredContent = WhatsPublic(content);
    return content = content
        .sort((a, b) => new Date(b.datePublished) - new Date(a.datePublished)) // Sort by datePublished (newest first)
};